<div
  class="flex flex-col justify-center items-start w-full min-h-[300px] space-y-2"
  testId="item-attributes-list"
>
  <div
    class="flex flex-row justify-between items-center w-full"
    *ngFor="let attribute of attributes$ | async"
  >
    <div class="flex flex-col justify-start items-start">
      <app-key-value-pair
        key="item-attribute-name-{{ attribute.id }}"
        [name]="attribute.name"
        [value]="attribute.latest_value | attributeValue : attribute.data_type"
      ></app-key-value-pair>
      <app-key-value-pair
        key="item-attribute-last-update-{{ attribute.id }}"
        class="text-sm"
        name="Last Updated"
        [value]="attribute.current_value | attributeValueTimestampUser | async"
      ></app-key-value-pair>
    </div>
    <button
      mat-flat-button
      (click)="updateAttributeValue(attribute)"
      testId="item-attribute-update-button-{{ attribute.id }}"
    >
      Update Value
    </button>
    <button
      mat-icon-button
      [matMenuTriggerFor]="moreMenu"
      testId="item-attribute-menu-trigger-{{ attribute.id }}"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #moreMenu>
      <button
        mat-menu-item
        (click)="editAttribute(attribute)"
        testId="edit-attribute-{{ attribute.id }}"
      >
        <mat-icon>edit</mat-icon>
        Edit
      </button>
      <button
        mat-menu-item
        (click)="deleteAttribute(attribute)"
        testId="delete-attribute-{{ attribute.id }}"
      >
        <mat-icon>delete</mat-icon>
        <span>Delete</span>
      </button>
    </mat-menu>
  </div>
  <button
    mat-flat-button
    class="self-center my-8"
    (click)="addAttribute()"
    testId="add-new-attribute"
  >
    Add New Attribute
  </button>
</div>
